(() => {
  if (window.gtfoProductInboxBound) return;
  window.gtfoProductInboxBound = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gtfo-open-inbox]');
    if (!button) return;
    const root = button.closest('[data-gtfo-product-assistance]');
    const status = root && root.querySelector('[data-gtfo-chat-status]');
    // Use the native Inbox custom element; leave message handling to Shopify.
    const chat = document.querySelector('shopify-chat');
    if (chat && customElements.get('shopify-chat')) {
      chat.setAttribute('mode', 'standalone');
      chat.setAttribute('open', '');
      if (status) status.hidden = true;
    } else {
      // Older Inbox embeds have no stable public opener; keep native chat available.
      if (status) { status.hidden = false; status.focus(); }
    }
  });
})();
